import React from 'react';
import PropTypes from 'prop-types';
import FacultyMemberCard from './Card';
import { Flex, Box } from 'rebass';
import Text from '../Text';

const FacultyMembers = ({ title, members }) => {
  return (
    <Flex flexDirection="column" m={-3}>
      <Box p={3}>
        <Text as="h2" fontSize={5} mb={4}>
          {title}
        </Text>
        <Flex flexWrap="wrap" m={-3}>
          {members.map(member => {
            return (
              <Box key={member.id} p={3} width={[1, null, 1 / 2]}>
                <FacultyMemberCard {...member} />
              </Box>
            );
          })}
        </Flex>
      </Box>
    </Flex>
  );
};

FacultyMembers.propTypes = {
  title: PropTypes.string,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
};

export default FacultyMembers;
